import React from 'react';
import './Badge.css';

/**
 * AURORA BADGE PRIMITIVE
 * 
 * A token-based badge component for labels, tags, and status indicators
 * All styling comes from tokens.css
 * 
 * Variants: 'default', 'primary', 'success', 'warning', 'error', 'info'
 * Sizes: 'sm', 'md', 'lg'
 * 
 * @example
 * ```jsx
 * <Badge>Default</Badge>
 * <Badge variant="success">Active</Badge>
 * <Badge variant="error" size="sm">Error</Badge>
 * <Badge variant="primary" dot>5 New</Badge>
 * ```
 */

const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  dot = false,
  removable = false,
  onRemove,
  className = '',
  ...props
}) => {
  const classes = [
    'aurora-badge',
    `aurora-badge--${variant}`,
    `aurora-badge--${size}`,
    dot && 'aurora-badge--with-dot',
    removable && 'aurora-badge--removable',
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} {...props}>
      {dot && <span className="aurora-badge-dot" aria-hidden="true" />}
      <span className="aurora-badge-content">{children}</span>
      {removable && (
        <button
          type="button"
          className="aurora-badge-remove"
          onClick={onRemove}
          aria-label="Remove"
        >
          <svg
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </span>
  );
};

Badge.displayName = 'Badge';

export default Badge;
